const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class GoodHarvest extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.GoodHarvest,
            "Each civilization produces food immediately. Ignore corruption and consumption.",
            {}
        )
    }
}

module.exports = GoodHarvest;